import { themeVariables } from "../../constants/tokens.js";
const markdownReplacements = {
  h1: {
    variant: "h3",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  h2: {
    variant: "h4",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  h3: {
    variant: "h5",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  h4: {
    variant: "h5",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  h5: {
    variant: "h6",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  h6: {
    variant: "h6",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  p: {
    variant: "body1",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  "body-xs": {
    variant: "body-xs",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  blockquote: {
    variant: "body2",
    sx: {
      fontStyle: themeVariables.fonts.style.italic
    }
  },
  list: {
    variant: "body1",
    sx: {
      whiteSpace: "pre-line",
      p: 0,
      m: 0
    }
  },
  a: {
    variant: "link",
    sx: {}
  }
};
export {
  markdownReplacements
};
